const PREFIXABLE_PATHS = ['/shop', '/cart', '/checkout', '/subscriptions', '/auctions', '/book', '/'];

const shouldPrefixPath = (path) => {
  if (!path || typeof path !== 'string') return false;
  if (!path.startsWith('/')) return false;
  return PREFIXABLE_PATHS.some((needle) => path === needle || path.startsWith(`${needle}/`));
};

const applyPartnerLinks = (links, { prefix, homePath, bookingPath } = {}) => {
  if (!Array.isArray(links)) return links;
  return links.map((item) => {
    if (!item || typeof item !== 'object') return item;
    const currentPath = item.path;

    // Partner pages use `/book` (or prefixed) rather than `/addbookings`.
    if (currentPath === '/addbookings' && bookingPath) {
      return { ...item, path: bookingPath };
    }

    if (currentPath === '/' && homePath) {
      return { ...item, path: homePath };
    }

    if (!prefix) return item;
    if (!shouldPrefixPath(currentPath)) return item;
    if (currentPath.startsWith(prefix)) return item;
    return { ...item, path: `${prefix}${currentPath}`.replace(/\/{2,}/g, '/') };
  });
};

export const buildPartnerNavigation = (navigation, { homePath, bookingPath } = {}) => {
  if (!navigation || typeof navigation !== 'object') return navigation;

  const resolvedHome = homePath || '/';
  const resolvedBooking = bookingPath || '';
  const prefix = resolvedHome && resolvedHome !== '/' ? String(resolvedHome).replace(/\/+$/, '') : '';

  // Only touch the sections that include customer-facing internal links.
  return {
    ...navigation,
    rideLinks: applyPartnerLinks(navigation.rideLinks, {
      prefix,
      homePath: resolvedHome,
      bookingPath: resolvedBooking,
    }),
    footerProducts: applyPartnerLinks(navigation.footerProducts, {
      prefix,
      homePath: resolvedHome,
      bookingPath: resolvedBooking,
    }),
  };
};

